package com.essntl.core.settings.domain.model.configuration

import com.essntl.core.settings.data.supabase.configuration.ConfigurationLogoDto

data class ConfigurationLogoModel(
    val url: String?,
) {
    fun toDto() =
        ConfigurationLogoDto(url = url)
}